var initAccordions = function initAccordions() {
  var accordions = document.querySelectorAll('.accordion');
  if (!accordions.length) {
    return;
  }
  accordions.forEach(function (accordion) {
    if (accordion.classList.contains('active')) {
      accordion.querySelector('.accordion__content').style.display = 'block';
    }
  });
  accordions.forEach(function (accordion) {
    var trigger = accordion.querySelector('.accordion__trigger');
    trigger.addEventListener('click', function () {
      var content = accordion.querySelector('.accordion__content');
      var siblings = Array.prototype.filter.call(accordions, function (el) {
        return el !== accordion;
      });
      if (accordion.classList.contains('active')) {
        accordion.classList.remove('active');
        content.style.display = 'none';
      } else {
        accordion.classList.add('active');
        siblings.forEach(function (sibling) {
          sibling.classList.remove('active');
          sibling.querySelector('.accordion__content').style.display = 'none';
        });
        content.style.display = 'block';
      }
    });
  });
};
export { initAccordions };